export default __webpack_public_path__ + "static/media/Mirage_Silverlake_Resia_0.5dbbe5d0.jpg";